import { Box, BoxProps } from '@mui/material';

export const VectorLegends = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="70"
        height="95"
        viewBox="0 0 70 95"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.23891 90.6517C0.21755 91.0723 -0.269465 92.2412 0.151131 93.2626C0.571727 94.2839 1.74066 94.7709 2.76202 94.3504L2.00046 92.501L1.23891 90.6517ZM57.5645 0.753984C56.8763 -0.109972 55.618 -0.252427 54.7541 0.435805L40.6751 11.6511C39.8112 12.3394 39.6687 13.5976 40.357 14.4616C41.0452 15.3256 42.3035 15.468 43.1674 14.7798L55.682 4.81061L65.6512 17.3252C66.3394 18.1892 67.5977 18.3316 68.4617 17.6434C69.3256 16.9552 69.4681 15.6969 68.7799 14.8329L57.5645 0.753984ZM2.00046 92.501L2.76202 94.3504C20.0737 87.2214 32.4525 77.5946 41.2177 62.8997C49.9351 48.2851 54.9762 28.8241 57.9875 2.22512L56.0002 2.00013L54.0129 1.77514C51.024 28.1761 46.065 46.965 37.7824 60.8506C29.5478 74.6559 17.9268 83.7796 1.23891 90.6517L2.00046 92.501Z"
          fill="#FBB92D"
        />
      </svg>
    </Box>
  );
};
